// @flow

import React from 'react';
import PlayingCard from '../../../components/PlayingCard';
import styles from './styles.module.scss';
import cn from 'classnames';
import { sortCards } from 'utils/game/sortRandomCards';
import { getPostflopMaxCards } from '../../../utils/postflopHand';
import { getPostflopActionPotFraction } from '../stepsHandler';

type Props = {
  combo: string,
  highlight: boolean,
  small: number,
  bet: number,
  big: number,
  call: number,
  check: number,
  raise: number,
  fold: number,
  isPlo5?: boolean,
  actionContext?: any,
}

const GameResult = ({
  combo,
  highlight,
  small,
  bet,
  big,
  call,
  check,
  raise,
  fold,
  isPlo5 = false,
  actionContext = {},
}: Props) => {
  const sortedCards = sortCards(combo, isPlo5);
  const cards = (Array.isArray(sortedCards) ? sortedCards : [])
    .slice(0, getPostflopMaxCards(isPlo5))
    .reduce((acc, card) => {
      const sameCardCount = acc.filter((item) => item.card === card).length;

      return [
        ...acc,
        {
          card,
          key: `${combo}-${card}-${sameCardCount}`,
        },
      ];
    }, []);

  const handlePercentages = () => {
    const getSizingClassName = (action) => (
      getPostflopActionPotFraction(action, actionContext) > 1 / 2
        ? styles.darkBet
        : styles.lightBet
    );
    const actions = [
      { key: 'fold', value: fold, className: styles.fold },
      { key: call ? 'call' : 'check', value: call || check, className: styles.call },
      { key: 'small', value: small, className: getSizingClassName('small') },
      { key: 'bet', value: bet, className: getSizingClassName('bet') },
      { key: 'raise', value: raise, className: getSizingClassName('raise') },
      { key: 'big', value: big, className: getSizingClassName('big') },
    ].filter((action) => Number(action.value) > 0);

    const handleValue = (value) => {
      if (value === 0) {
        return ('');
      }
      return (
        <>
          {value}
          %
        </>
      );
    };

    return (
      <div className={styles.linesWrapper}>
        {actions.map((action) => (
          <div className={styles.row} key={action.key}>
            <div className={styles.rowPercentageWrapper}>
              <div
                className={cn(action.className, styles.border)}
                style={{ width: `${action.value}%` }}
              />
            </div>
            <div className={styles.rowValue}>
              {handleValue(action.value)}
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div
      className={cn(styles.resultWrapper, { [styles.highlight]: highlight })}
    >
      <div className={styles.resultCards}>
        <div className={styles.handCards}>
          {cards.map(({ card, key }) => (
            <PlayingCard size="xs" key={key} suit={card[1]} value={card[0]} noSuit />
          ))}
        </div>
        <div className={styles.percentagesWrapper}>
          {handlePercentages()}
        </div>
      </div>
    </div>
  );
};

export default GameResult;
